module.exports = __webpack_public_path__ + "img/Weapon_24.2686d0ab.png";